import { useState, useCallback, useRef } from "react";

interface UsePaymentIframeResult {
  iframeRef: React.RefObject<HTMLIFrameElement>;
  iframeLoading: boolean;
  iframeError: boolean;
  handleIframeLoad: () => void;
  handleIframeError: () => void;
  resetIframeState: () => void;
}

export const usePaymentIframe = (): UsePaymentIframeResult => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeLoading, setIframeLoading] = useState(true);
  const [iframeError, setIframeError] = useState(false);

  const handleIframeLoad = useCallback(() => {
    console.log("Payment iframe loaded successfully");
    setIframeLoading(false);
    setIframeError(false);
  }, []);

  const handleIframeError = useCallback(() => {
    console.error("Payment iframe failed to load");
    setIframeLoading(false);
    setIframeError(true);
  }, []);

  const resetIframeState = useCallback(() => {
    setIframeLoading(true);
    setIframeError(false);
  }, []);

  return {
    iframeRef,
    iframeLoading,
    iframeError,
    handleIframeLoad,
    handleIframeError,
    resetIframeState,
  };
};
